module.exports = __webpack_public_path__ + "static/img/celoscope-detail-37.80fdc56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-37.jpg
// module id = Q1ei
// module chunks = 51